import loadable from '@loadable/component';

const LoadableDesktopCalendarPicker = loadable(() =>
  import(/* webpackChunkName: "desktop-calendar" */ './DesktopCalendarPicker')
);

export default LoadableDesktopCalendarPicker;
